const API_HOST = "https://demo-api-dot-askbot-web.oa.r.appspot.com";

function API() {}

API.prototype.login = function() {
    window.location.href = API_HOST + "/auth/google/init";
}

API.prototype.getTokenData = async function( token ) {
    const url = API_HOST + "/login";
    try {
        let data = await ( await fetch( url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            }
        })).json();

        if (
            data.status != null
                && data.status == "OK"
            && data.data != null
                && data.data.source != null
                && data.data.uid != null
        ) {
            return data.data;
        }

    } catch ( e ) {
        console.warn( "Failed to getTokenData: ", e );
    }
    return false;
};

API.prototype.getPusherInstance = function( token ) {
    console.log( "API.getPusherInstance" );

    // Enable pusher logging - don't include this in production
    window.Pusher.logToConsole = true;

    return new window.Pusher('2e10babe45964e001e40', {
        cluster: 'eu',
        encrypted: true,
        authEndpoint: API_HOST + "/pusher/auth",
        auth: {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
    });
};

API.prototype.sendChat = function( token, data ) {
    fetch( API_HOST + "/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token,
        },
        body: JSON.stringify( data )
    })
};

export default new API();
